'use strict';

import React, { Component } from 'react';

import Form from "react-jsonschema-form";
import PopUp from '../../../commonModules/interface/PopUp';

class ValidationOverlayJsonForm extends Component{
    state = {
        // popupState: this.props.popupStateButton, 
        msg: this.props.msg,errormsg:""
    }
    // componentWillReceiveProps(nextProps) {
    //     // You don't have to do this check first, but it can help prevent an unneeded render
    //     if (nextProps.popupStateButton !== this.state.popupState) {
    //         this.setState({popupState: nextProps.popupStateButton});
    //     }
    // }
    // cancel = async (e) => {
    //     e.preventDefault();
    //     console.log("Cancel Validation");
    //     this.setState({popupState: false,errormsg:""});
    //     this.props.onCancelation();
    // }
    valid= async (e) => {
        e.preventDefault();            
        console.log('Record Json format')
        try {
            let url = '/schema/new'
            if (this.props.report ) {
                url = '/schema/maintenance/new' 
            } else if (this.props.quotation) {
                url = '/schema/quotation/new'
            } else if (this.props.sav) {
                url = '/schema/sav/new'
            }else if (this.props.complementary) {
                url = '/schema/complementary/new'
            }
            
            e.preventDefault();
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    // 'X-Requested-With': 'XMLHttpRequest',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',                    
                body: JSON.stringify({name: this.props.name,jsonSchema: this.props.jsonSchema, uiSchema: this.props.uiSchema})
            });
            const resp = await response.json();
            console.log(resp);
            if (resp.msg != "OK" ){
                this.setState({errormsg: resp.err.toString()});                    
                return;
            }
            // this.setState({popupState: false});
            this.props.onValidation();
        } catch (err) {
            this.setState({
                errormsg: 'Error : ' + err.error
            });
        }
    }
    componentDidMount() {}
    componentWillUnmount() {
        try {
            this.serverRequest.abort();
        } catch (e) {
            console.log(e);
        }
    }
    render() {
        console.log("[DEBUG], ValidationOverlayJsonForm, Button Proceed");
        return (
            <PopUp
                close={this.props.onCancelation}
                submitAction={this.valid}
                title={`Previsualisation de : ${this.props.name}`}
            >
                <Form
                    className="bootgrid-header container-fluid"
                    schema={this.props.jsonSchema}
                    uiSchema={this.props.uiSchema} 
                />
                    
                <i style={{color: "red"}}><p>{this.state.errormsg}</p></i>
                {/* <div className="text-right">
                    <button className="btn btn-cancel" onClick={this.cancel}>Cancel</button>
                    <button className="btn btn-primary" onClick={this.valid}>Ok</button>
                </div> */}
            </PopUp>
        );
    }
};

export default ValidationOverlayJsonForm